import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const CashierRestricted = ({
  closeModal,
  onShowLiveChat
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Cashier Restricted
      </div>
      <div className={styles.bold}>
        {'Your deposits are currently restricted pending additional account verification. An email has been sent to your registered email outlining what is required.'}
        <br />
        {'If you have a cash balance that you would like to withdraw or would like additional information, please contact customer service.'}
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeModal}
        style={{ marginRight: 16 }}
      >{"I'll do it later"}</Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={onShowLiveChat}
      >Live Chat</Button>
    </div>
  </Fragment>
);

CashierRestricted.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onShowLiveChat: PropTypes.func.isRequired,
};

export default CashierRestricted;

